import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { Modal, Radio, Button, Form } from "antd";
import "./index.scss";
import applyIcon from "../../../assets/images/new-apply-icon.png";
import applyIconLight from "../../../assets/images/new-apply-icon-light.png";
import checkIcon from "../../../assets/images/re-apply-icon.png";
import checkIconLight from "../../../assets/images/re-apply-icon-light.png";
import resultIcon from "../../../assets/images/footer-icon.png";
import selfTestTopIcon from "../../../assets/images/selfTestBg.png";

import ApplyFlow from "../ApplyFlow";

const questionList = [
  {
    key: "contract",
    title: "您是否与宝山区的劳动单位签订一年及以上的劳动合同？",
    choice: ["是", "否"],
  },
  // {
  //   key: "marry",
  //   title: "您的婚姻状况为？",
  //   choice: ["未婚", "已婚", "离异", "丧偶"],
  // },
  {
    key: "domicile",
    title: "您的户籍所在地为？",
    choice: ["本市", "外省市"],
  },
  {
    key: "otherApply",
    title: "您是否有同时申请本市其它保障性住房(含廉租住房及共有产权保障房)？",
    choice: ["是", "否"],
  },
  {
    key: "personalArea",
    title:
      "您是否符合本区保租房人均住房建筑面积核算相关规定（人均住房建筑面积低于15㎡）？",
    subTitle:
      "申请家庭成员本市名下房产，人均住房建筑面积应低于15㎡",
    choice: ["是", "否", "不确定"],
  },
  {
    key: "residenceCertificate",
    title: "您是否持有在有效期内的本市居住证件？",
    choice: ["是", "暂无居住证"],
  },
  {
    key: "socialInsurance",
    title: "您在本市是否有依法缴纳各项社会保险金？",
    choice: ["是", "暂未缴纳"],
  },
  {
    key: "keyEnterprises",
    title: "您所在的用人单位是否属于我区重点企事业单位？",
    choice: ["是", "否", "不确定"],
  },
  {
    key: "unitAssistance",
    title: "您所在的用人单位是否同意帮助您以单位名义进行申请？",
    choice: ["是", "否"],
  },
];

const SelfTest = ({ }, ref) => {
  const [open, setOpen] = useState(false);
  const [testType, setTestType] = useState("1");
  const [tips, setTips] = useState("");
  const [testResult, setTestResult] = useState(false);
  const applyFlowRef = useRef();
  const [form] = Form.useForm();
  const [dynamicQuestions, setDynamicQuestions] = useState([questionList[0]]);

  useImperativeHandle(ref, () => ({ openModal }), []);

  const openModal = () => {
    setOpen(true);
  };

  const onCancel = () => {
    setOpen(false);
    setTestType("1");
    setTips("");
    setTestResult(false);
    setDynamicQuestions([questionList[0]]);
    form.resetFields();
  };

  //   切换新申请/续租复审
  const testTypeChange = ({ target: { value } }) => {
    setTestType(value);
    if (value === "2") {
      setTips(
        "续租申请按原申请条件执行（首次申请时以单位名义申请提交《居住证办理承诺》及《单位缴金承诺书》的申请人，复核时必需持有有效期内居住证件及社保缴费证明）。"
      );
    } else {
      setTestResult(false);
      setTips("");
      setDynamicQuestions([questionList[0]]);
      form.resetFields();
    }
  };

  //   提交测试
  const submitTest = async () => {
    const values = await form.validateFields();
    // 合同
    if (values.contract && values.contract === "否") {
      setTips(
        "我司保租房属宝山区区筹保租房，申请人需与宝山区的劳动单位签订一年及以上的劳动合同。若不满足该项条件，则需申请人具有本区常住户口（含社区公共户），请您确认是否满足该项条件，若不满足，则无法通过资格申请。"
      );
    }
    // 其他申请
    if (values.otherApply && values.otherApply === "是") {
      setTips(
        "保障类住房无法同时申请或同时享受，您暂不满足我区保租房申请条件，谢谢！"
      );
    }
    // 人均面积
    if (values.personalArea) {
      if (values.personalArea === "是") {
        setTips("经系统预审，您大致具备我区保租房申请条件。");
      } else if (values.personalArea === "否") {
        setTips(
          "您的人均住房建筑面积已超过我区保租房申请相关规定，暂不满足申请条件，谢谢！"
        );
      } else {
        setTips(
          "请您与我司取得联系确认相关人均住房建筑面积计算方法，以确认您是否满足该项申请条件，谢谢！"
        );
      }
    }

    // 重点企业
    if (values.keyEnterprises) {
      if (values.keyEnterprises === "否") {
        setTips(
          "经系统初步判定，因未持有有效期内本市居住证件/未依法缴纳各项社会保险金，且您所在单位不属于我区重点企事业单位。暂不符合我区保租房申请条件。"
        );
      } else if (values.keyEnterprises === "不确定") {
        setTips(
          "您暂未持有有效期内本市居住证件/未依法缴纳各项社会保险金，请与我司取得联系确认您所在用人单位是否属于我区重点企事业单位，若不属于则不满足申请条件，谢谢！"
        );
      } else {
      }
    }

    // 重点企业
    if (values.unitAssistance) {
      if (values.unitAssistance === "否") {
        setTips(
          "经系统判定，因您暂未持有有效期内本市居住证件/未依法缴纳各项社会保险金，必须经由单位同意进行单位名义申请，故您暂不满足我区保租房申请条件，谢谢！"
        );
      }
    }

    setTestResult(true);
  };

  //   申请流程、一图读懂
  const applyFlowDetal = () => {
    applyFlowRef.current.openApplyFlow();
  };

  const getNextQuestion = (k) => {
    return questionList.find((v) => v.key === k);
  };

  const changeResult = (v, i) => {
    const list = [...dynamicQuestions].slice(0, i + 1);
    const lastValues = form.getFieldsValue();
    form.resetFields();
    form.setFieldsValue(lastValues);
    const values = form.getFieldsValue();
    // 合同
    if (v.key === "contract" && values.contract && values.contract === "是") {
      // list.push(getNextQuestion("marry"));
      list.push(getNextQuestion("domicile"));
    }
    // 婚姻
    // if (v.key === "marry" && values.marry) {
    //   list.push(getNextQuestion("domicile"));
    // }
    // 户籍
    if (v.key === "domicile" && values.domicile) {
      if (values.domicile === "本市") {
        list.push(getNextQuestion("otherApply"));
      } else {
        list.push(getNextQuestion("residenceCertificate"));
      }
    }
    // 居住证
    if (v.key === "residenceCertificate" && values.residenceCertificate) {
      if (values.residenceCertificate === "是") {
        list.push(getNextQuestion("socialInsurance"));
      } else {
        list.push(getNextQuestion("keyEnterprises"));
      }
    }
    // 社保
    if (v.key === "socialInsurance" && values.socialInsurance) {
      if (values.socialInsurance === "是") {
        list.push(getNextQuestion("otherApply"));
      } else {
        list.push(getNextQuestion("keyEnterprises"));
      }
    }
    // 重点企业
    if (v.key === "keyEnterprises" && values.keyEnterprises) {
      if (values.keyEnterprises === "是") {
        list.push(getNextQuestion("unitAssistance"));
      }
    }
    // 单位申请
    if (v.key === "unitAssistance" && values.unitAssistance) {
      if (values.unitAssistance === "是") {
        list.push(getNextQuestion("otherApply"));
      }
    }

    // 同时申请其他保租房
    if (v.key === "otherApply" && values.otherApply) {
      if (values.otherApply === "否") {
        list.push(getNextQuestion("personalArea"));
      }
    }

    setDynamicQuestions(list);
    setTestResult(false);
  };

  return (
    <>
      <Modal
        className="self-test-modal"
        title={<img src={selfTestTopIcon} alt="" />}
        open={open}
        visible={open}
        onCancel={onCancel}
        destroyOnClose={true}
        maskClosable={false}
        mask={false}
        footer={null}
        width={1000}
        bodyStyle={{ background: "#edf5ff" }}
      >
        <div>
          <div className="desc">
            系统将会根据您的填写初步判断您是否符合保租房。
          </div>
          <div>
            <div style={{ padding: 20, background: "#fff" }}>
              <div style={{ borderBottom: "1px solid #1890ff" }}>
                <Radio.Group
                  options={[
                    {
                      label: (
                        <div>
                          <img
                            src={testType === "1" ? applyIconLight : applyIcon}
                            alt=""
                            width={13}
                            style={{ marginRight: 8 }}
                          />
                          新申请
                        </div>
                      ),
                      value: "1",
                    },
                    {
                      label: (
                        <div>
                          <img
                            src={testType === "2" ? checkIconLight : checkIcon}
                            alt=""
                            width={13}
                            style={{ marginRight: 8 }}
                          />
                          续租复审
                        </div>
                      ),
                      value: "2",
                    },
                  ]}
                  onChange={testTypeChange}
                  value={testType}
                  optionType="button"
                  buttonStyle="solid"
                />
              </div>
              {/* 自测问题 */}
              {testType === "1" ? (
                <div>
                  <div className="question">
                    <Form form={form}>
                      {dynamicQuestions.map((v, i) => (
                        <div
                          key={v.key}
                          style={{
                            borderBottom: "1px dotted #d8d8d8",
                            padding: "15px 15px 0",
                          }}
                        >
                          <div style={{ marginBottom: 10 }}>
                            {i + 1}. {v.title}
                          </div>
                          <div style={{ fontSize: 12, color: "#666666" }}>
                            {v.subTitle}
                          </div>
                          <div>
                            <Form.Item
                              name={v.key}
                              rules={[{ required: true, message: "请选择" }]}
                            >
                              <Radio.Group onChange={() => changeResult(v, i)}>
                                {v.choice.map((c) => (
                                  <Radio key={c} value={c}>
                                    {c}
                                  </Radio>
                                ))}
                              </Radio.Group>
                            </Form.Item>
                          </div>
                        </div>
                      ))}
                    </Form>
                  </div>
                  <div className="submitBtn" onClick={submitTest}>
                    提交测试
                  </div>
                </div>
              ) : null}

              {/* 结果 */}
              {testType === "2" || testResult ? (
                <div className="result">
                  {/* 测试结果icon */}
                  {testType === "1" ? (
                    <div style={{ textAlign: "center" }}>
                      <img src={resultIcon} alt="" />
                    </div>
                  ) : null}
                  <div style={{ background: "#fff", padding: 20, margin: 20 }}>
                    <div className="tips">温馨提示：{tips}</div>
                    {/* 中间网站电话 */}
                    {testType === "2" ||
                      tips.includes("具备我区保租房申请条件") ? (
                      <div style={{ margin: "15px 0" }}>
                        <div className="tips">
                          申请保租房资格证可通过以下渠道办理：
                        </div>
                        <div className="web">
                          ①登录 “随申办” 微信小程序、支付宝小程序或 APP
                        </div>
                        <div className="web">②访问一网通办官网</div>
                        <div className="tips">
                          搜索“公共租赁住房申请审核”入口，按指引填写并提交相关资料即可完成申请。
                        </div>
                        <div style={{ margin: "15px 0" }}>
                          <Button type="primary" ghost onClick={applyFlowDetal}>
                            点击查看申请流程
                          </Button>
                        </div>
                        <div className="tel">
                          若两个平台均无法申请，请致电 56671727或56100661。
                        </div>
                        <div className="tel">
                          注：港澳台及外籍人员，请直接致电
                          56671727或56100661办理。
                        </div>
                      </div>
                    ) : null}

                    <div className="withoutLegal">
                      (*最终以实际申请审核结果为准*)
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </Modal>
      <ApplyFlow ref={applyFlowRef} />
    </>
  );
};

export default forwardRef(SelfTest);
